/** Product name shown where no school is in context (platform console, public pages). */
export const APP_NAME = 'SchoolEduca'
